import React, { useContext, useEffect, useState } from "react";
import ServiceWrapper from "../../../Services/ServiceWrapper";
import AppSettings from "../../../Settings/AppSettings";
import AuthManager from "../../../Common/AuthManager";
import { CategoryContext } from "./CategoryContext";
import { AppContext } from "../../../Context/AppContext";
import Bootbox from "../../../Common/BootBoxManager";
import { Link } from "react-router-dom";
import Label from "../../Common/components/Label";
import { toast } from "react-toastify";
import SmallOutlinedButton from "../../Common/components/SmallOutlinedButton";
import "./Category.css";
import Utils from "../../../Common/Utils";

function AddEditViewCategoryType() {
  let appContext = useContext(AppContext);
  let industryId =
    appContext.get_selected_industry() && appContext.get_selected_industry().id;
  const appData = useContext(AppContext);

  const categoryTypeContextData = useContext(CategoryContext);
  let [loading, setLoading] = React.useState(false);
  let [savingInfo, setsavingInfo] = React.useState({
    done: null,
    message: "",
  });
  let [errorMessage, setErrorMessage] = useState(null);
  let initialStateObject = {
    id: "",
    name: "",
    description: "",
    active: true
  };
  const validationOptions = {
    name: {
      required: true,
      minLength: 2,
      maxLength: 60,
      type: "alnum_with_spaces",
    },
  };
  const [disableButtons, setDisableButtons] = useState(true);
  let [categoryTypeDetail, setCategoryTypeDetail] =
    React.useState(initialStateObject);
  let [categoryTypeDetailCopy, setCategoryTypeDetailCopy] =
    React.useState(null);

  async function load_CategoryType_detail() {
    setLoading(true);
    let api_base_url = AppSettings.GMS_BACKEND_API_URL;
    let res = await ServiceWrapper.doGet(
      api_base_url +
      "categorytype/details/" +
      categoryTypeContextData.editingItem.id,
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (!res.errorfound) {
      await setCategoryTypeDetail(res.data.data[0]);
      await setCategoryTypeDetailCopy(res.data.data[0]);
      setLoading(false);
      setDisableButtons(true);
    } else {
      setLoading(false);
      setErrorMessage(
        "Error while fetching details, Please try after some time."
      );
    }
  }

  async function hande_change(e) {
    let temp = JSON.parse(JSON.stringify(categoryTypeDetail));
    temp[e.target.name] =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setCategoryTypeDetail(temp);
  }

  useEffect(() => {
    const validation = Utils.validate(categoryTypeDetail, validationOptions);
    if (
      !validation[0] ||
      JSON.stringify(categoryTypeDetail) ===
      JSON.stringify(categoryTypeDetailCopy)
    ) {
      setDisableButtons(true);
    } else setDisableButtons(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryTypeDetail]);

  // function cancel_changes() {
  //   if (categoryTypeContextData.editingItem.id === "0") {
  //     setCategoryTypeDetail(initialStateObject);
  //   } else {
  //     setCategoryTypeDetail(categoryTypeDetailCopy);
  //   }
  // }

  async function save_changes() {
    setDisableButtons(true);
    setsavingInfo(null);

    let api_base_url = AppSettings.GMS_BACKEND_API_URL;

    let final_details = categoryTypeDetail;
    let final_url = `${api_base_url}categorytype/edit/${categoryTypeContextData.editingItem.id}`;
    if (
      categoryTypeContextData.editingItem.type === "ct" &&
      categoryTypeContextData.editingItem.id === "0"
    ) {
      final_url = `${api_base_url}categorytype/create`;
      final_details = {
        ...categoryTypeDetail,
        industry_id: industryId,
      };
    }
    let res = await ServiceWrapper.doPost(
      final_url,
      final_details,
      null,
      AuthManager.getGmsToken()
    );
    if (!res.errorfound) {
      // categoryTypeContextData.setLoading(false);
      if (res.data.done) {
        toast.success(res.data.message);
        if (
          categoryTypeContextData.editingItem.type === "ct" &&
          categoryTypeContextData.editingItem.id === "0"
        ) {
          setCategoryTypeDetail(initialStateObject);
          setCategoryTypeDetailCopy(initialStateObject);
          setDisableButtons(true);
        } else {
          setCategoryTypeDetailCopy(categoryTypeDetail);
        }
        if (categoryTypeContextData.editingItem.id !== "0") {
          handle_reload_list(categoryTypeContextData.editingItem.id);
        } else {
          handle_reload_list(res?.data?.id);
        }
      } else {
        toast.error(res.data.message);
        setDisableButtons(false);
      }
    } else {
      setDisableButtons(false);
      setsavingInfo({
        done: false,
        message: "Error while saving, Please try after some time.",
      });
    }
    setDisableButtons(true);
    setTimeout(() => {
      setsavingInfo({
        done: null,
        message: "",
      });
    }, 5000);
  }

  useEffect(() => {
    if (
      JSON.stringify(categoryTypeDetail) ===
      JSON.stringify(initialStateObject) ||
      !categoryTypeDetail.name.trim()
    ) {
      setDisableButtons(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryTypeDetail]);

  function handle_reload_list(id) {
    categoryTypeContextData.setEditingItem({
      type: "ct",
      form: "view",
      id: id,
    });
    if (categoryTypeDetailCopy) {
      if (
        !(
          categoryTypeDetail.name === categoryTypeDetailCopy.name &&
          categoryTypeDetail.active === categoryTypeDetailCopy.active
        )
      ) {
        categoryTypeContextData.setListReloadCounter((n) => n + 1);
      }
    } else {
      categoryTypeContextData.setListReloadCounter((n) => n + 1);
    }
    copy_categoryType_detail();
  }

  function copy_categoryType_detail() {
    let temp = JSON.parse(JSON.stringify(categoryTypeDetail));
    setCategoryTypeDetailCopy(temp);
  }

  useEffect(() => {
    if (categoryTypeContextData.editingItem.form === "edit") {
      if (
        categoryTypeContextData.editingItem.type === "ct" &&
        categoryTypeContextData.editingItem.id !== "0"
      ) {
        load_CategoryType_detail();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryTypeContextData.editingItem]);

  const handleOnSaveClick = () => {
    if (appData.pm.checkPermission("gmscategory_update")) {
      if (categoryTypeDetail?.name.trim() !== "") {
        save_changes();
      } else {
        toast.error("Please enter a valid name");
      }
    } else {
      toast.info("You do not have permission to save the category type");
    }
  }

  const handleOnCancelClick = () => {
    categoryTypeContextData.editingItem.id === "0"
      ? categoryTypeContextData.setEditingItem((prev) => ({ id: categoryTypeContextData.categoryTypeList[0]?.id ?? undefined, type: "ct", form: "view" }))
      : categoryTypeContextData.setEditingItem((prev) => ({ id: prev?.id, type: "ct", form: "view" }));
  }

  return (
    <React.Fragment>
      {categoryTypeContextData.editingItem.form === "view" ? (
        <CategoryTypeDetails />
      ) : (
        <>
          {loading && (
            <div className="">
              <div className="col-3 mb-4 p-1 skeleton"></div>
              <div className="border p-2 ps-3 rounded-1">
                <div className="ps-3 row">
                  <div className="row col-6">
                    <div className="col-6 p-3 skeleton"></div>
                  </div>
                  <div className="col-6 justify-content-end ms-4 pb-3 row">
                    <div className="col-4 p-1 skeleton"></div>
                  </div>
                </div>
                <div className="mb-5 p-3 mt-4 skeleton"></div>
                <div className="mb-4 p-3 p-5 skeleton"></div>
              </div>
            </div>
          )}
          {!loading &&
            (errorMessage ? (
              <div
                className="alert alert-danger bg-white small p-2"
                role="alert"
              >
                <span className="fas fa-exclamation-triangle" />
                &nbsp;
                <strong>{errorMessage}</strong>
              </div>
            ) : (
              <>
                <div className="mt-1">
                  {" "}
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb tw-ms-3.5">
                      <li className="breadcrumb-item tw-pointer-events-none">
                        <Link to="#">
                          <Label
                            message="Taxonomy"
                            fontSize={0.75}
                            fontWeight="400"
                            color="#5c5f62"
                          />
                        </Link>
                      </li>
                      <li
                        className="breadcrumb-item active tw-pointer-events-none"
                        aria-current="page"
                      >
                        <Label
                          message={categoryTypeDetail ? categoryTypeDetail?.name : ""}
                          fontSize={0.75}
                          fontWeight="500"
                          color="#5c5f62"
                        />
                      </li>
                    </ol>
                  </nav>
                </div>
                <div className="border-1 shadow p-3 shadow-none card">
                  <div className="d-flex justify-content-between">
                    <div>
                      <Label
                        message={`${categoryTypeContextData.editingItem.id === "0"
                          ? "Create "
                          : "Edit "
                          } Category Type`}
                        fontSize={1.125}
                        fontWeight="600"
                      />
                      {categoryTypeContextData.editingItem.id !== "0" && (
                        <>
                          {" "}
                          <br />
                          <Label
                            message={`UID: ${categoryTypeContextData.editingItem.id !== "0"
                              ? categoryTypeContextData.editingItem.id
                              : ""
                              }`}
                            fontSize={0.7}
                            fontWeight="600"
                            color="#424242"
                          />{" "}
                        </>
                      )}
                    </div>

                    <div className="tw-flex tw-gap-3 float-end">


                      <button onClick={handleOnCancelClick} className="samll-outline-btn">Cancel</button>
                      <button disabled={disableButtons} onClick={handleOnSaveClick} className="small-filled-btn">Save</button>

                    </div>
                  </div>
                  <div className="row">&nbsp;</div>
                  <form>
                    <div className="mb-3">
                      <Label message=" Name" htmlFor="name" />
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        name="name"
                        style={{
                          fontSize: "0.8rem",
                          color: "black",
                          fontWeight: "500",
                          fontFamily: "Noto Sans",
                          border: `1px solid ${categoryTypeDetail?.name?.length > 2
                            ? "#ced4da"
                            : "#c13e25"
                            }`,
                        }}
                        placeholder="Enter Category Type Name"
                        value={categoryTypeDetail.name || ""}
                        onChange={(e) => hande_change(e)}
                        aria-describedby="nameHelp"
                        maxLength="60"
                        minLength="2"
                      />
                      <div id="nameHelp" className="form-text">
                        <Label
                          message="Name must be 2-60 characters long, contain letters,
                          numbers and spaces, and must not contain special
                          characters."
                          fontSize={0.7}
                          fontWeight="600"
                          color="#B0B0B0"
                        />
                      </div>
                    </div>

                    <div className="mb-3">
                      <Label
                        fontSize={0.8}
                        message="Description"
                        htmlFor="description"
                      />
                      {/* <label htmlFor="description" className="form-label">
                      Description :
                    </label> */}
                      <textarea
                        className="form-control"
                        id="description"
                        name="description"
                        style={{ fontSize: ".8rem", fontWeight: "600" }}
                        rows="5"
                        placeholder="Enter description"
                        onChange={(e) => hande_change(e)}
                        value={categoryTypeDetail.description || ""}
                      />
                    </div>
                    <div className="float-start">
                      {savingInfo !== null ? (
                        <>
                          {savingInfo.done ? (
                            <div
                              className="alert alert-primary bg-white small p-1"
                              role="alert"
                            >
                              <i className="far fa-check-circle" />
                              &nbsp;
                              <strong>{savingInfo.message}</strong>
                            </div>
                          ) : (
                            <>
                              {savingInfo.done === false && (
                                <div
                                  className="alert alert-danger border-0 bg-white small p-2"
                                  role="alert"
                                >
                                  <span className="fas fa-exclamation-triangle" />
                                  &nbsp;
                                  <strong>{savingInfo.message}</strong>
                                </div>
                              )}
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          <div
                            className="alert  alert-info bg-white small p-2"
                            role="alert"
                          >
                            <span className="fas fa-circle-notch fa-spin" />
                            &nbsp;
                            <strong>Saving your Changes</strong>
                          </div>
                        </>
                      )}
                    </div>
                  </form>
                </div>
              </>
            ))}
        </>
      )}
    </React.Fragment>
  );
}

export default AddEditViewCategoryType;

const CategoryTypeDetails = () => {
  let api_base_url = AppSettings.GMS_BACKEND_API_URL;
  const { editingItem, setEditingItem, setListReloadCounter, setDeleteInfo } =
    useContext(CategoryContext);
  const appData = useContext(AppContext);

  let [loading, setLoading] = React.useState({
    status: "",
    message: "",
  });

  let [categoryTypeDetail, setCategoryTypeDetail] = React.useState();

  const [clipText, setClipText] = useState(null);

  function handle_clipbord(text) {
    navigator.clipboard.writeText(text).then(() => setClipText(text));
  }

  useEffect(() => {
    load_CategoryType_detail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editingItem.id]);

  async function load_CategoryType_detail() {
    setLoading({ status: "loading", message: "Loading Category Type Details" });
    let res = await ServiceWrapper.doGet(
      api_base_url + "categorytype/details/" + editingItem.id,
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (!res.errorfound) {
      setLoading({ status: "success", message: "" });
      await setCategoryTypeDetail(res.data.data[0]);
    } else {
      setLoading({ status: "Error", message: "Error while loading details" });
    }
  }

  async function handle_delete_categoryType(categoryType) {
    setDeleteInfo({
      status: "Loading",
      message: "Deleting selected Category Type",
    });

    let res = await ServiceWrapper.doGet(
      api_base_url + "categorytype/delete/" + categoryType.id,
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (!res.errorfound) {
      if (res.data.done) {
        toast.success(res.data.message);
        if (
          editingItem !== null &&
          editingItem !== undefined &&
          editingItem.type === "ct" &&
          editingItem.id === categoryType.id
        ) {
          setEditingItem(null);
        }
        setListReloadCounter((n) => n + 1);
      } else {
        setDeleteInfo({
          status: "Error",
          message: "Deletion of Category type Failed",
        });

        window["bootbox"].dialog({
          title: "Category Type Deletion Failure",
          message:
            "<p>We are Sorry, We could not delete the selected Category Type Below is more information.</p><p><strong>" +
            res.data.message +
            "</strong></p>",
          size: "medium",
          closeButton: false,
          centerVertical: true,
          buttons: {
            ok: {
              label: "OK, I got it",
              className: "button-fill",
              callback: function () {
                console.log("Custom OK clicked");
              },
            },
          },
        });
      }
    } else {
      setDeleteInfo({
        status: "Error",
        message: "Error while deleting selected category type!!",
      });
    }
    setTimeout(() => {
      setDeleteInfo({
        status: null,
        message: "",
      });
    }, 5000);
  }

  return (
    <>
      <nav aria-label="breadcrumb" className="tw-ms-2 tw-mt-2">
        <ol className="breadcrumb">
          <li className="breadcrumb-item tw-pointer-events-none">
            <Link to="#">
              <Label
                message="Taxonomy"
                fontSize={0.75}
                fontWeight="400"
                color="#5c5f62"
              />
            </Link>
          </li>
          <li className="breadcrumb-item active tw-pointer-events-none" aria-current="page">
            <Label
              message={loading.status === "success" && categoryTypeDetail ? categoryTypeDetail?.name : ""}
              fontSize={0.75}
              fontWeight="500"
              color="#5c5f62"
            />
          </li>
        </ol>
      </nav>

      {loading.status === "loading" && (
        <div className="border ms-1 p-3 rounded">
          <div className="col-2 p-3 skeleton"></div>
          <div className="col-4 p-2 skeleton"></div>
          <div className="col-2 p-2 skeleton"></div>
        </div>
      )}

      {loading.status === "Error" && (
        <div className="alert alert-primary bg-white small p-2" role="alert">
          <span className="fas fa-exclamation-triangle" />
          &nbsp;
          <strong>{loading.message}</strong>
        </div>
      )}
      {loading.status === "success" && categoryTypeDetail && (
        <>
          <div className="border tw-px-2 tw-py-2 tw-ml-2">
            <div className="d-flex justify-content-between ps-0 pb-0">
              <div className="ps-0 pb-0">
                <Label
                  message={categoryTypeDetail.name}
                  fontSize={1.125}
                  fontWeight="600"
                />
              </div>

              <div className="d-flex">
                <SmallOutlinedButton
                  name="Edit"
                  onClick={() => {
                    if (appData.pm.checkPermission("gmscategory_update")) {
                      setEditingItem({
                        type: "ct",
                        form: "edit",
                        id: categoryTypeDetail.id,
                      });
                    } else {
                      toast.success(
                        "You don't have permission to update the category type"
                      );
                    }
                  }}
                />
                &nbsp;&nbsp;
                <div className="bd-highlight">
                  <li
                    className="nav-item dropdown"
                    style={{ listStyleType: "none" }}
                  >
                    <div role="group">
                      <i
                        id="btnGroupDrop1"
                        className="fas fa-ellipsis-v pt-1"
                        style={{
                          fontSize: "0.75rem",
                          cursor: "pointer",
                          color: "#091caa",
                        }}
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        onClick={() => null}
                      />

                      <div className="dropdown-menu p-0">
                        <Link
                          className="dropdown-item"
                          to="#"
                          style={{ fontSize: "0.875rem" }}
                          onClick={() => {
                            if (
                              appData.pm.checkPermission("gmscategory_delete")
                            ) {
                              Bootbox.confirm(
                                "",
                                `${categoryTypeDetail.name}`,
                                false,
                                [handle_delete_categoryType, categoryTypeDetail]
                              );
                            } else {
                              toast.success(
                                "You don't have permission to delete the category type"
                              );
                            }
                          }}
                        >
                          Delete
                        </Link>
                      </div>
                    </div>
                  </li>
                </div>
                &nbsp;&nbsp;
              </div>
            </div>
            <div className="col col-md-12 cat">
              <p className="small mb-1">
                <span style={{ fontSize: "" }} className="">
                  <span
                    style={{
                      fontSize: "0.875",
                      color: "#000000",
                      fontFamily: "Noto Sans",
                      fontWeight: "500",
                    }}
                  >
                    UID&nbsp;&nbsp;
                  </span>
                  <Label
                    message={`${categoryTypeDetail.id || ""}`}
                    fontSize={0.875}
                    fontFamily="Noto Sans"
                    fontWeight="400"
                    color="#5c5f62"
                  />
                </span>
                &nbsp;&nbsp;
                <i
                  className={`${clipText === null ? "far" : "fas"
                    } fa-clipboard`}
                  style={{
                    fontSize: "0.95rem",
                    cursor: "pointer",
                    color: "#091caa",
                  }}
                  onClick={() => handle_clipbord(categoryTypeDetail.id)}
                />
                &nbsp;&nbsp;
                <Label
                  message={clipText === null ? "" : "UID Copied"}
                  fontSize={0.75}
                  color="#488328"
                />
              </p>
              <div className="ps-0 mt-0">
                <span className="ps-0">
                  <Label
                    message={categoryTypeDetail.description}
                    color="#000000"
                    fontWeight="400"
                  />
                </span>
              </div>
              <br />
            </div>
          </div>
        </>
      )}
    </>
  );
};
